import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Gertrude",
  "description": "",
  "published": "2007-06-14T00:00:00.000Z",
  "redirect_from": ["/blog/gertrude/swizec/187"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`VÄeraj sem se malÄek igral z Getrude, mojim LEGO trebuchetem in se odloÄil posneti kratek video bedne kvalitete. Moral bi bil to spraviti na blog Å¾e vÄeraj pa mi je nekak ušlo iz misli.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      